// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"bf941694","787":"6f80b264"}[chunkId] + ".chunk.js";
};